/* global axios */

const accountId = () => {
  if (window.location.pathname.includes('/app/accounts')) {
    return window.location.pathname.split('/')[3];
  }

  return '';
};

class OfficialSellersAPI {
  get({ includeInactive = false } = {}) {
    return axios.get(
      `/api/v1/accounts/${accountId()}/aceleres/official_sellers`,
      {
        params: includeInactive ? { include_inactive: true } : {},
      }
    );
  }

  create(seller) {
    return axios.post(
      `/api/v1/accounts/${accountId()}/aceleres/official_sellers`,
      seller
    );
  }

  update(chatwootUserId, seller) {
    return axios.patch(
      `/api/v1/accounts/${accountId()}/aceleres/official_sellers/${chatwootUserId}`,
      seller
    );
  }

  sync(chatwootUserId) {
    return axios.post(
      `/api/v1/accounts/${accountId()}/aceleres/official_sellers/sync`,
      {
        chatwoot_user_id: chatwootUserId,
      }
    );
  }

  deactivate(chatwootUserId) {
    return axios.post(
      `/api/v1/accounts/${accountId()}/aceleres/official_sellers/deactivate`,
      {
        chatwoot_user_id: chatwootUserId,
      }
    );
  }

  reactivate({ chatwootUserId, aceleresUserId }) {
    return axios.post(
      `/api/v1/accounts/${accountId()}/aceleres/official_sellers/reactivate`,
      {
        chatwoot_user_id: chatwootUserId,
        aceleres_user_id: aceleresUserId,
      }
    );
  }

  deleteLocal(aceleresUserId) {
    return axios.delete(
      `/api/v1/accounts/${accountId()}/aceleres/official_sellers/aceleres/${aceleresUserId}`
    );
  }
}

export default new OfficialSellersAPI();
